import { z } from "zod";
export const ProcessRequest = z.object({
    prompt: z.string().min(1).max(2000),
    userId: z.string().optional(),
    contextualPersonalization: z.boolean().default(false),
    contentTypes: z.array(z.enum(["reset", "story", "recipe"])).default([]),
    maxItems: z.number().int().min(1).max(10).optional(),
    themes: z.array(z.string()).default([]),
    locale: z.string().optional(),
});
export const ProcessResponse = z.record(z.string(), z.unknown());
//# sourceMappingURL=process.js.map